import React, { useContext, useEffect, useState } from "react";
import BoxPayGrid from "../../BoxPayGrid";
import OfferManagementContext from "../../../context/offerManagement.context";
import NoOrLowCostEmiSchema from "./noOrLowCostEmiSchema";
import ContentHeader from "../../../reusableComponents/contentHeader/ContentHeader";
import "./noOrLowCostEmi.css";
import CustomButton from "../../../reusableComponents/CustomButton";
import { useNavigate } from "react-router-dom";
import InputSearchComponent from "../../../reusableComponents/inputSearchComponent";
import SmallModal from "../../../reusableComponents/modals/SmallModal";
import { useRef } from "react";
import { useAuth } from "../../../context/API_Client";
import { customToast } from "../../../reusableComponents/customToaster/customToast";

export default function NoOrLowCostEmi({ setLoading }) {
  const navigate = useNavigate();
  const { deleteEmiOfferById, updateEmiRule } = useAuth();
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [isFilledBtnLoading, setIsFilledBtnLoading] = useState(false);
  const offerDataRef = useRef();
  const confirmationMszRef = useRef();
  const confirmationMszHeaderRef = useRef();
  const { allNoOrLowCostOffers, resetContext, setAllNoOrLowCostOffers, pageNo, setPageNo, pageLimit, setPageLimit, totalDataCount } = useContext(OfferManagementContext);

  // pageNo={pageNo}
  // setPageNo={setPageNo}
  // pageLimit={pageLimit}
  // setPageLimit={setPageLimit}
  // totalDataCount={totalDataCount}
  const optionsToDisplayInSearch = [
    {
      title: "Offer Title",
      value: "title"
    }
    // {
    //   title: "Offer Code",
    //   value: "code"
    // },
    // {
    //   title: "Offer Type",
    //   value: "discount.type"
    // }
  ];

  const handleEditOffer = (data) => {
    navigate("/offerManagement/editEmiOffer", { state: { editData: data } });
  }
  const handleDeleteOffer = (data) => {
    offerDataRef.current = data.data;
    confirmationMszHeaderRef.current = `Delete Offer ?`
    confirmationMszRef.current = `Are you sure you want to delete ${offerDataRef.current.title} ?`
    offerDataRef.current['func'] = handleOfferDeleteConfirmation;
    setShowConfirmationModal(true);
  }
  const handleEnableOffer = (data) => {
    offerDataRef.current = { ...data.data };
    delete offerDataRef.current.criteria.startDate;
    confirmationMszHeaderRef.current = `Enable Offer ?`
    confirmationMszRef.current = `Are you sure you want to enable ?`
    offerDataRef.current.enabled = true;
    offerDataRef.current['func'] = handleOfferStatusToggle;
    setShowConfirmationModal(true);
  }
  const handleDisableOffer = (data) => {
    offerDataRef.current = { ...data.data };
    delete offerDataRef.current.criteria.startDate;
    confirmationMszHeaderRef.current = `Disable Offer ?`
    confirmationMszRef.current = `Are you sure you want to disable ?`
    // confirmationMszRef.current = `Are you sure you want to disable ${offerDataRef.current.title} ?`
    offerDataRef.current.enabled = false;
    offerDataRef.current['func'] = handleOfferStatusToggle;
    setShowConfirmationModal(true);
  }

  const handleOfferStatusToggle = () => {
    setIsFilledBtnLoading(true)
    delete offerDataRef.current.func;
    const payload = offerDataRef.current;

    updateEmiRule(payload, payload?.code,
      function (data) {
        setAllNoOrLowCostOffers(prev => {
          prev[prev.findIndex(d => d.code === data.code)] = data;
          return [...prev]
        });
        setIsFilledBtnLoading(false)
        setShowConfirmationModal(false);
        customToast("success", "medium", `${payload.enabled ? 'Enabled' : 'Disabled'} successfully`);
      }, function (error) {
        setIsFilledBtnLoading(false)
        setShowConfirmationModal(false);
        customToast("error", "high", error);
      });
  }
  const handleOfferDeleteConfirmation = () => {
    setIsFilledBtnLoading(true)
    deleteEmiOfferById(
      offerDataRef.current.code,
      (data) => {
        setAllNoOrLowCostOffers(prev => {
          let index = prev.findIndex(d => d.code === data.code);
          prev.splice(index, 1);
          return [...prev]
        });
        setIsFilledBtnLoading(false);
        customToast("success", "high", 'Deleted successfully');
        setShowConfirmationModal(false);
      },
      (error) => {
        setIsFilledBtnLoading(false);
        setShowConfirmationModal(false);
        customToast("error", "high", error);
      }
    );
  }

  return (
    <>
      <div className="content-wrapper whiteBg">
        <section className="content">
          <div className="noOrLowCostTableDiv">
            <ContentHeader
              firstHeading="Create Custom Discount & No or Low Cost EMI Offers"
              secondHeading="Offer discounts and cashback to attract customers and improve sales"
              icon={<img src="/assets/offers/seal-question.svg" alt="offers" />}
            />
            <div className="offerManagementSearchDiv">
              <div className="offerInputFieldWidth">
                <InputSearchComponent optionsToDisplayInSearch={optionsToDisplayInSearch} />
              </div>
              <CustomButton
                variant={"contained"}
                size={"md"}
                type={"primary"}
                text={"Create No or Low Cost EMI"}
                onClick={() => { navigate("/offerManagement/createEmiOffer"); resetContext() }}
              />
            </div>
            <BoxPayGrid
              schema={NoOrLowCostEmiSchema(
                handleEditOffer,
                handleDeleteOffer,
                handleEnableOffer,
                handleDisableOffer
              )}
              data={allNoOrLowCostOffers}
              showCustomizeButton={false}
              customPagination={true}
              pageNo={pageNo}
              setPageNo={setPageNo}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              totalDataCount={totalDataCount}
            />
          </div>
        </section>

        {
          showConfirmationModal && (
            <SmallModal
              headerText={confirmationMszHeaderRef.current}
              subHeaderText={confirmationMszRef.current}
              icon={<img src="/assets/routingIcons/ExclamationCircle.svg" />}
              toggleDialog={showConfirmationModal}
              outlinedBtnText={"No"}
              outlinedBtnFunction={() => { setShowConfirmationModal(false); }}
              filledBtnText={"Yes"}
              filledBtnFunction={offerDataRef.current.func}
              isFilledBtnLoading={isFilledBtnLoading}
            />
          )
        }
      </div>
    </>
  );
}
